import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CAMPAIGN_USER_ID } from "~/constants/app";
import { UserProfileErrorComponent } from "~/features/profile/components/UserProfileErrorComponent";
import { UserProfileSkeleton } from "~/features/profile/components/UserProfileSkeleton";
import { UserProfileTemplate } from "~/features/profile/UserProfileTemplate";
import { fukadaLiveRecordingQueryOptions } from "~/lib/queryOptions/fukadaLiveRecording";
import {
  publicImagesQueryOptions,
  userProfileQueryOptions,
} from "~/lib/queryOptions/userProfileQueryOptions";

// 遷移元を示す search param。"instant-call"（今すぐビデオ通話できるユーザー一覧）から
// 来たときだけ通話可能の強調演出を出す。
const profileSearchSchema = z.object({
  from: z.literal("instant-call").optional(),
});

const ProfileUserPage = () => {
  const { userId } = Route.useParams();
  const { from } = Route.useSearch();
  return (
    <UserProfileTemplate
      userId={userId}
      highlightInstantCall={from === "instant-call"}
    />
  );
};

export const Route = createFileRoute("/_authenticated/profile/$userId")({
  validateSearch: profileSearchSchema,
  loader: ({ context: { queryClient }, params: { userId } }) =>
    Promise.all([
      queryClient.ensureQueryData(userProfileQueryOptions(userId)),
      queryClient.ensureQueryData(publicImagesQueryOptions(userId)),
      ...(userId === CAMPAIGN_USER_ID
        ? [queryClient.ensureQueryData(fukadaLiveRecordingQueryOptions)]
        : []),
    ]),
  pendingMs: 200,
  pendingMinMs: 300,
  pendingComponent: UserProfileSkeleton,
  errorComponent: UserProfileErrorComponent,
  component: ProfileUserPage,
});
